/* eslint-disable @typescript-eslint/no-unused-vars */
import moment from 'moment';
import { safeParseJson } from '../../lib';
import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, CompanyType } from '../../model';
import {
  CommonStatusStep,
  IAPIAdminCompanyInfoRes,
  IAPIAdminCompanyListRes,
  IAPICommonCosConfigRes,
  IAPICompanyFullInfo,
  IAPICompanyRes,
  StudioCertifiedType,
} from '../../model/api-modules';
import { ADMIN_COMPANY_PREFIX, ADMIN_PREFIX } from '../config';

// 获取工作室企业信息
export const getCompanyList = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_COMPANY_PREFIX}/approval`;
      const response = await api.commonRequest('GET', url);

      const res = await parsedResponse<IAPIAdminCompanyListRes>(
        response,
        'data'
      );

      const data: ReadonlyArray<IAPICompanyFullInfo> = [
        ...(res.companyRes || []),
        ...(res.studioCertRes || []),
      ].map((companyInfo) => {
        if ('CertInfo' in companyInfo) {
          return {
            ...companyInfo,
            certifiedType: StudioCertifiedType.InternalKpiCode,
            InternalCertInfo: safeParseJson(companyInfo?.CertInfo),
          };
        }

        const approvalInfo =
          res.approvalRes.find(
            (item) => item.StudioID === companyInfo.StudioID
          ) || {};

        return {
          ...approvalInfo,
          ...companyInfo,
          certifiedType: StudioCertifiedType.Company,
        };
      });

      return [...data].sort((a, b) => {
        return (a.CreateTime || '') < (b.CreateTime || '') ? 1 : -1;
      });
    } catch (error) {
      console.log(error);
      return;
    }
  });

export const getSupportCompanyInfo = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_COMPANY_PREFIX}/info/${studioId}`;
      const response = await api.commonRequest('GET', url);

      const res = await parsedResponse<IAPIAdminCompanyInfoRes>(
        response,
        'data'
      );

      res.validateCertInfo = moment(
        res.company?.ModifyTime || '1990-1-1'
      ).isBefore(moment(res.studioCertRes?.ModifyTime || '1990-1-1'))
        ? res.studioCertRes
        : res.company;

      res.isCertified =
        res.validateCertInfo?.Status === CommonStatusStep.Resolve;

      res.certifiedType = res.isCertified
        ? 'CertInfo' in (res.validateCertInfo || {})
          ? StudioCertifiedType.InternalKpiCode
          : StudioCertifiedType.Company
        : undefined;

      return res;
    } catch (error) {
      console.log(error);
      return;
    }
  });

// 审核
export const companyApproval = (
  studioID: string,
  data: {
    status: CommonStatusStep;
    companyType?: CompanyType;

    rejectReason?: string;
  }
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_COMPANY_PREFIX}/approval/${studioID}`;
      const response = await api.commonRequest('PUT', url, data);

      const res = await parsedResponse<IAPIAdminCompanyListRes>(
        response,
        'data'
      );

      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  });

export const companyInternalApproval = (
  studioID: string,
  data: {
    status: CommonStatusStep;
    rejectReason?: string;
  }
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_COMPANY_PREFIX}/approval/${studioID}/internal-studio`;
      const response = await api.commonRequest('PUT', url, data);

      const res = await parsedResponse<IAPIAdminCompanyListRes>(
        response,
        'data'
      );

      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  });
export const companyUnbind = (studioID: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_COMPANY_PREFIX}/approval/${studioID}/unbind`;
      const response = await api.commonRequest('PUT', url);
      await parsedResponse(response, 'data');
      return true;
    } catch (error) {
      console.log(error);
      return;
    }
  });

export const getSupportCompanyCosConfig = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/cos/sts/company/config`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAPICommonCosConfigRes>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      console.log(error);
      return;
    }
  });

export const getSupportCompanyCosSts = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/cos/sts/company`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<any>(response, 'data');
      return res;
    } catch (error) {
      return false;
    }
  });
